module.exports = __webpack_public_path__ + "static/media/shripad_kulkarni.c4bcd3cf.png";